import { makeApolloClient, logError } from '../util';
import { EVENT_AUDIT } from 'queries/audit';
export const SET_AUDIT = 'SET_AUDIT';
export const CLEAR_AUDIT = 'CLEAR_AUDIT_DATA';

const setAudit = (audit, from) => ({
	type: SET_AUDIT,
	audit,
	from,
});

export const clearAudit = from => ({
	type: CLEAR_AUDIT,
	from,
});

export const thunkFetchEventAudit = (gqlParams, from, preventDispatch = false) => async (
	dispatch,
	getState
) => {
	const client = makeApolloClient(getState());
	try {
		// console.log("thunkFetchEventAudit request");
		// console.log(gqlParams);
		// console.log(from);
		const { searchAuditHistory } = await client.request(EVENT_AUDIT, gqlParams);
		// console.log("thunkFetchEventAudit response");
		// console.log(searchAuditHistory);
		if (!preventDispatch) {
			dispatch(setAudit(searchAuditHistory, from));
		}
		return searchAuditHistory.nodes;
	} catch (error) {
		logError('audit.actions.thunkFetchEventAudit', error);
	}
};
